import { useParams, useNavigate } from "react-router-dom";
import { useState , useEffect } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import { Country, State, City } from "country-state-city";
import Swal from "sweetalert2";

export default function EnrollForm({ isModal = false, onClose }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [courseData, setCourseData] = useState(null);
  const [form, setForm] = useState({
    name: "",
    email: "",
    emailOtp: "",
    phone: "",
    country: "IN",
    state: "",
    city: "",
    status: "Working Professional",
    course: "",
    experience: "No prior experience",
    modeOfLearning: "Online",
    message: "",
  });

  const [generatedEmailOtp, setGeneratedEmailOtp] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);

  const countries = Country.getAllCountries();
  const states = State.getStatesOfCountry(form.country);
  const cities = City.getCitiesOfState(form.country, form.state);
  const selectedCountry = Country.getCountryByCode(form.country);
  const phoneCode = selectedCountry?.phonecode || "91";
 useEffect(() => {
  const fetchCourse = async () => {
    try {
      const res = await fetch(
  `https://swiftintelli.com/api/getCourse.php?slug=${slug}`
);
      const data = await res.json();

     console.log(JSON.stringify(data, null, 2));

      setCourseData(data);

      setForm((prev) => ({
        ...prev,
        course: data?.title || "",
      }));
    } catch (err) {
      console.log(err);
    }
  };

  if (slug) {
    fetchCourse();
  }
}, [slug]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const sendEmailOtp = async () => {
    if (!form.email) {
      Swal.fire({ icon: "warning", title: "Enter Email", text: "Please enter your email address first.", confirmButtonColor: "#2563eb" });
      return;
    }
    const otp = Math.floor(100000 + Math.random() * 900000).toString();
    setGeneratedEmailOtp(otp);
    try {
      await axios.post("https://swiftintelli.com/api/send-email-otp.php", { email: form.email, otp });
      setOtpSent(true);
      Swal.fire({ icon: "success", title: "OTP Sent!", text: "OTP has been sent to " + form.email, confirmButtonColor: "#2563eb", timer: 2500, timerProgressBar: true });
    } catch (error) {
      console.log(error);
      Swal.fire({ icon: "error", title: "Failed!", text: "Could not send OTP. Please try again.", confirmButtonColor: "#2563eb" });
    }
  };

  const verifyEmailOtp = () => {
    if (form.emailOtp === generatedEmailOtp) {
      setEmailVerified(true);
      Swal.fire({ icon: "success", title: "Email Verified!", text: "Your email has been verified successfully.", confirmButtonColor: "#2563eb", timer: 2000, timerProgressBar: true });
    } else {
      Swal.fire({ icon: "error", title: "Invalid OTP", text: "The OTP you entered is incorrect. Please try again.", confirmButtonColor: "#2563eb" });
    }
  };

  const submit = async () => {
    if (!emailVerified) {
      Swal.fire({ icon: "warning", title: "Verify Email First", text: "Please verify your email before submitting.", confirmButtonColor: "#2563eb" });
      return;
    }
    if (!form.phone) {
      Swal.fire({ icon: "warning", title: "Enter Phone Number", text: "Please enter your phone number.", confirmButtonColor: "#2563eb" });
      return;
    }
    setLoading(true);
    try {
      const res = await fetch("https://swiftintelli.com/api/enroll.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...form,
          course_id: courseData?.id,
          phoneCode,
          countryName: selectedCountry?.name,
          stateName: states.find((s) => s.isoCode === form.state)?.name,
        }),
      });
  const text = await res.text();

console.log("SERVER RESPONSE:", text);

const cleanText = text
  .replace(/```php/g, "")
  .replace(/```/g, "")
  .trim();

const data = JSON.parse(cleanText);
      if (data.status === "success") {
        await fetch("https://swiftintelli.com/api/sendEnrollMail.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: form.name,
            email: form.email,
            phone: "+" + phoneCode + " " + form.phone,
            country: selectedCountry?.name,
            state: states.find((s) => s.isoCode === form.state)?.name,
            city: form.city,
            status: form.status,
            course: form.course,
            experience: form.experience,
            message: form.message,
          }),
        });
        setSubmitted(true);
        Swal.fire({
          icon: "success",
          title: "🎉 Enrollment Successful!",
          text: "You have successfully enrolled. We'll get in touch with you soon!",
          confirmButtonColor: "#2563eb",
          confirmButtonText: "Great, Thanks!",
          showConfirmButton: true,
          allowOutsideClick: false,
        }).then(() => {
          if (isModal && onClose) onClose();
          else navigate("/");
        });
   } else if (data.status === "exists") {

  Swal.fire({
    icon: "info",
    title: "Already Enrolled",
    text: data.message,
    confirmButtonColor: "#2563eb",
  });

} else {

  Swal.fire({
    icon: "error",
    title: "Enrollment Failed",
    text: data.message || "Something went wrong",
    confirmButtonColor: "#2563eb",
  });

}
   } catch (err) {

  console.error(err);

  Swal.fire({
    icon: "error",
    title: "Server Error",
    text: "Something went wrong",
  });

}
    setLoading(false);
  };

  const formContent = (
    <div className="si-form-inner">
      {isModal && (
        <button className="si-close-btn" onClick={onClose} aria-label="Close">✕</button>
      )}

      <h2 className="si-form-title">Enroll Now</h2>

      {/* NAME */}
      <input
        className="si-input"
        placeholder="Full Name"
        name="name"
        value={form.name}
        onChange={handleChange}
      />

      {/* EMAIL + SEND OTP */}
      <div className="si-row">
        <input
          className="si-input"
          placeholder="Email Address"
          name="email"
          value={form.email}
          onChange={handleChange}
          disabled={otpSent}
          style={{ opacity: otpSent ? 0.7 : 1 }}
        />
        <button
          className="si-otp-btn"
          onClick={sendEmailOtp}
          disabled={otpSent}
          style={{ opacity: otpSent ? 0.6 : 1, cursor: otpSent ? "not-allowed" : "pointer" }}
        >
          {otpSent ? "Sent ✓" : "Send OTP"}
        </button>
      </div>

      {/* OTP INPUT + VERIFY — only show after OTP sent */}
      {otpSent && (
        <div className="si-row">
          <input
            className="si-input"
            placeholder="Enter Email OTP"
            name="emailOtp"
            value={form.emailOtp}
            onChange={handleChange}
            disabled={emailVerified}
            style={{ opacity: emailVerified ? 0.7 : 1 }}
          />
          <button
            className={`si-otp-btn ${emailVerified ? "si-otp-btn--verified" : ""}`}
            onClick={verifyEmailOtp}
            disabled={emailVerified}
            style={{ cursor: emailVerified ? "not-allowed" : "pointer" }}
          >
            {emailVerified ? "Verified ✓" : "Verify"}
          </button>
        </div>
      )}

      {/* COUNTRY */}
      <select className="si-select" name="country" value={form.country} onChange={handleChange}>
        {countries.map((c) => (
          <option key={c.isoCode} value={c.isoCode}>{c.name}</option>
        ))}
      </select>

      {/* STATE + CITY side by side */}
      <div className="si-row si-row--selects">
        <select className="si-select" name="state" value={form.state} onChange={handleChange}>
          <option value="">Select State</option>
          {states.map((s) => (
            <option key={s.isoCode} value={s.isoCode}>{s.name}</option>
          ))}
        </select>
        <select className="si-select" name="city" value={form.city} onChange={handleChange}>
          <option value="">Select City</option>
          {cities.map((c) => (
            <option key={c.name} value={c.name}>{c.name}</option>
          ))}
        </select>
      </div>

      {/* PHONE */}
      <div className="si-row">
        <input className="si-input si-phone-code" value={`+${phoneCode}`} readOnly />
        <input
          className="si-input"
          placeholder="Phone Number"
          name="phone"
          value={form.phone}
          onChange={handleChange}
        />
      </div>

      {/* STATUS + COURSE side by side */}
      <div className="si-row si-row--selects">
        <select className="si-select" name="status" value={form.status} onChange={handleChange}>
          <option>Working Professional</option>
          <option>Student</option>
          <option>Fresher</option>
        </select>
        
      </div>

      {/* EXPERIENCE + MODE side by side */}
      <div className="si-row si-row--selects">
        <div className="si-select-group">
          <select className="si-select" name="experience" value={form.experience} onChange={handleChange}>
            <option>No prior experience</option>
            <option>Beginner</option>
            <option>Intermediate</option>
          </select>
        </div>
        <div className="si-select-group">
          <label className="si-label">Mode of Learning</label>
          <select className="si-select si-select--no-mt" name="modeOfLearning" value={form.modeOfLearning} onChange={handleChange}>
            <option value="Online">Online</option>
            <option value="Offline">Offline</option>
          </select>
        </div>
      </div>

      {/* MESSAGE */}
      <textarea
        className="si-textarea"
        placeholder="Message (optional)"
        name="message"
        value={form.message}
        onChange={handleChange}
      />

      {/* SUBMIT */}
      <button
        className="si-submit-btn"
        onClick={submit}
        disabled={loading || submitted}
      >
        {loading ? "Submitting..." : submitted ? "Submitted ✅" : "Submit Application →"}
      </button>
    </div>
  );

 if (isModal) {
  return (
    <div className="si-modal-overlay">

      <div
        className="si-modal-box"
        onClick={(e) => e.stopPropagation()}
      >

        {formContent}

      </div>

    </div>
  );
}

  return (
    <div className="si-root">
      <Navbar />
      <div className="si-page-wrapper">
        {formContent}
      </div>
    </div>
  );
}